import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { SBOMContext } from '../../../pages/NRSBOMTable/NRSBOMDataShare';

function SBOMAddComponentButton() {
  const theme = useTheme();
  const { openAddDependencyModal, setOpenAddDependencyModal } = useContext(SBOMContext);

  const handleClick = () => {
    setOpenAddDependencyModal(true);
  };

  return (
    <Button
      id="sbom-add-component-button"
      aria-controls="basic-menu"
      aria-haspopup="true"
      variant="outlined"
      color="secondary"
      aria-expanded={openAddDependencyModal ? 'true' : undefined}
      onClick={handleClick}
      sx={{
        textTransform: 'none',
        height: theme.spacing(4.5)
      }}
    >
      <Typography variant="subtitle2" component="span">
        Add Component
      </Typography>
    </Button>
  );
}

export default SBOMAddComponentButton;
